import styled from 'styled-components'
import Text from '../shared/Text'
import RetryButton from '../shared/RetryButton'
import {
	ZapLikeIcon,
	fast_charger_pin,
	regular_charger_pin,
} from '../../utility/icons'
import styles from '../../utility/styles'

const Wrapper = styled.div`
	width: 100%;
	display: flex;
`

const ZapsWrapper = styled.div`
	display: flex;
	flex: 1;
	overflow-x: scroll;
	height: 250px;
`

const ZapButton = styled.button`
	padding: 0;
	border: none;
	marginright: 4px;
	position: relative;
	border-radius: 1px;
	margin-right: 6px;
	background-color: transparent;
`

const Thumbnail = styled.img`
	height: 250px;
	width: 149px;
	border-radius: 1px;
`

const LikesRow = styled.div`
	position: absolute;
	right: 10px;
	bottom: 10px;
	display: flex;
	align-items: center;
`

const ZapMapContainer = styled.div`
	height: 100%;
	width: 450px;
	min-width: 450px;
	margin-right: 24px;
	background-color: var(--tz-surface-raised, #1A202C);
	display: flex;
	align-items: center;
	justify-content: center;
	background-image: url("${({ imageSrc }) => imageSrc}");
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
	position: relative;
`

const Pin = styled.img`
	position: absolute;
	left: 50%;
	top: 50%;
	height: 48px;
	margin-left: -12px;
	margin-top: -24px;
`

/**
 *
 * @param {{
 *   zapsArray:any[],
 *   isFastCharger:boolean,
 *   onZapClick:(id:string)=>void,
 *   imageSrc:string,
 *   style:import('react').CSSProperties
 *   zapsError:string,
 *   retry:()=>Promise<Void>
 * }} props
 * @returns
 */
export default function ZapsCarousel({
	zapsArray = [],
	isFastCharger,
	onZapClick,
	imageSrc,
	zapsError,
	retry,
	style,
}) {
	return (
		<Wrapper {...{ style }}>
			<ZapsWrapper>
				{Boolean(zapsError) && <RetryButton onClick={retry} />}
				{zapsArray.map(zap => (
					<ZapButton onClick={() => onZapClick(zap.id)} key={zap.id}>
						<Thumbnail src={zap.media[0]?.thumb_url} />
						{zap.likes > 0 && (
							<LikesRow>
								<ZapLikeIcon />
								<Text.Tiny variant='bold'>
									{zap.likes}
								</Text.Tiny>
							</LikesRow>
						)}
					</ZapButton>
				))}
				<ZapMapContainer {...{ imageSrc }}>
					<Pin
						src={
							isFastCharger
								? regular_charger_pin
								: fast_charger_pin
						}
					/>
				</ZapMapContainer>
			</ZapsWrapper>
		</Wrapper>
	)
}
